// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { gameController } from "../../../game_theme/flow_fb/flowController";
import { ComponentButton } from "../../framework/components/ComponentButton";
import { ComponentContainer } from "../../framework/components/ComponentContainer";
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { DialogBase } from "../../framework/dialogs/DialogBase";
import { tgfDictionary } from "../../framework/tgfDictionary";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { DialogSettings, GraphicsSettings } from "../../settings/Settings";
import { angrybirds_regular } from "../AssetDefinitions/FontDefinitions";
import { s_btn_round_blue, s_icon_settings, s_btn_orange, s_button_glow3, s_buttonpowerbg, s_buttonbg_mighty_scope, s_buttonbg_mighty_scope_active } from "../AssetDefinitions/ImageDefinitions";
import { MightyScopeDialog } from "../LobbyCode/MightyScopeDialog";
import { CardComponent } from "./CardComponent";
import { PowerUpBarDialog } from "./PowerUpBarDialog";
import { ScoreBarDialog } from "./ScoreBarDialog";
export var UIController = function (openSettingsDialog, onLobbyButtonPressed, countPigs, canSwapPigs, isPlacingPowerup, getSharedData, isShooting, isWaitingForPlayerWithoutDialog, isWaitingScreenOpen) {
    this.openSettingsDialog = openSettingsDialog;
    this.onLobbyButtonPressed = onLobbyButtonPressed;
    this.countPigs = countPigs;
    this.canSwapPigs = canSwapPigs;
    this.isPlacingPowerup = isPlacingPowerup;
    this.getSharedData = getSharedData;
    this.isShooting = isShooting;
    this.isWaitingForPlayerWithoutDialog = isWaitingForPlayerWithoutDialog;
    this.isWaitingScreenOpen = isWaitingScreenOpen;
    this.scoreBarAnimation = 1;
    this.cardAnimation = 1;
    this.settingsButtonAnimation = 1;
    this.lobbyButtonAnimation = 1;
    this.powerupsUiAnimation = 1;
    this.mightyScopeButtonAnimation = 1;
};
UIController.prototype.initUI = function (isInitiatingPlayer) {
    "use strict";
    var self = this;
    this.ui = new DialogBase({
        x: 0,
        y: 0
    });
    this.buttonContainer = new ComponentContainer();
    this.ui.addComponent(this.buttonContainer);
    this.lobbyButton = new ComponentButton({
        image: s_btn_round_blue,
        icon: s_icon_settings,
        iconPosition: "center",
        width: 50,
        height: 50,
        x: tgfGraphics.areaWidth - 50,
        y: tgfGraphics.areaHeight - 50,
        onClick: this.openSettingsDialog
    });
    this.buttonContainer.addComponent(this.lobbyButton);
    this.lobbyButtonContainer = new ComponentContainer();
    this.ui.addComponent(this.lobbyButtonContainer);
    this.lobbyButtonWaitingForOpp = new ComponentButton({
        image: s_btn_orange,
        // x: tgfGraphics.areaWidth / 2, 
        // y: tgfGraphics.areaHeight - 78,
        text: tgfDictionary.getText("BTN_RETURN_TO_LOBBY"),
        fontUp: {
            fontFace: angrybirds_regular.fontFace,
            fontSize: 40,
            fillColor: "#ffffff",
            align: "center",
            baseline: "middle",
            shadow: { active: true, color: '#371d1d', offsetX: 2, offsetY: 3, blur: 1, distance: 4 }
        },
        onClick: this.onLobbyButtonPressed,
        fontDown: this.buttonFont
    });
    this.lobbyButtonContainer.addComponent(this.lobbyButtonWaitingForOpp);
    this.scoreBarDialog = new ScoreBarDialog({
        isInitiatingPlayer: isInitiatingPlayer,
        getSharedData: this.getSharedData,
        countPigs: this.countPigs
    });
    this.scoreBarDialog.show();
    this.cardContainer = new ComponentContainer();
    this.ui.addComponent(this.cardContainer);
    this.cardGlow = new ComponentPicture({
        x: 85,
        y: tgfGraphics.areaHeight - 85,
        image: s_button_glow3,
        xScale: 2,
        yScale: 2,
        alpha: 0.7
    });
    this.cardContainer.addComponent(this.cardGlow);
    this.uiCards = new CardComponent({
        x: tgfGraphics.areaWidth - 50,
        y: tgfGraphics.areaHeight - 50
    });
    this.cardContainer.addComponent(this.uiCards);
    this.uiPowerUps = new PowerUpBarDialog({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight - 78,
        canSwapPigs: this.canSwapPigs,
        isPlacingPowerup: this.isPlacingPowerup
    });
    this.uiPowerUps.show();
    this.uiPowerUps.setState(this.uiPowerUps.STATE.NOTHING);
    // Mighty scope UI
    this.mightyScopeButtonContainer = new ComponentContainer();
    this.ui.addComponent(this.mightyScopeButtonContainer);
    this.mightyScopeButtonBackground = new ComponentPicture({
        image: s_buttonpowerbg,
        xScale: 0.9,
        yScale: 0.9,
    });
    this.mightyScopeButtonContainer.addComponent(this.mightyScopeButtonBackground);
    this.mightyScopeButton = new ComponentButton({
        image: s_buttonbg_mighty_scope,
        x: 0,
        y: 0,
        onClick: this._handleScopeButtonClick.bind(this),
    });
    this.mightyScopeButtonContainer.addComponent(this.mightyScopeButton);
    this.inactiveMightyScopeButton = new ComponentPicture({
        image: s_buttonbg_mighty_scope_active,
        x: 0,
        y: 0,
    });
    this.mightyScopeButtonContainer.addComponent(this.inactiveMightyScopeButton);
    this.inactiveMightyScopeButtonText = new ComponentLabel({
        text: "9:59",
        font: DialogSettings.buttonFontSmall,
        x: 1,
        y: 19,
    });
    this.mightyScopeButtonContainer.addComponent(this.inactiveMightyScopeButtonText);
    this.ui.show();
    this.handleUIMovement(0, true);
};
UIController.prototype.updateUI = function (isInitiatingPlayer) {
    if (isInitiatingPlayer) {
        this.scoreBarDialog.setPigScore(this.countPigs(true), this.countPigs(false));
    }
    else {
        this.scoreBarDialog.setPigScore(this.countPigs(false), this.countPigs(true));
    }
};
UIController.prototype.handleUIMovement = function (timePassed, uiHidden) {
    this.uiHidden = uiHidden;
    this._handleScoreBarMovement();
    this._handleCardMovement();
    this._handleSettingsButtonMovement();
    this._handleLobbyButtonMovement();
    this._handlePowerupMovement();
    this._handleCardGlow();
    this._handleScopeButtonUpdate();
};
UIController.prototype._handleScoreBarMovement = function () {
    this.scoreBarAnimation += (0.08 * (this.uiHidden ? GraphicsSettings.hudHideSpeed : GraphicsSettings.hudShowSpeed)) * (this.uiHidden - this.scoreBarAnimation);
    var uiScalar = 1 + 0.8 * this.scoreBarAnimation;
    this.scoreBarDialog.setPosition(this.scoreBarDialog.x, -0.5 * (uiScalar * tgfGraphics.areaHeight - tgfGraphics.areaHeight));
};
UIController.prototype._handleCardMovement = function () {
    var cardsHidden = this.uiHidden || (this.countPigs(true) === 0) || (this.countPigs(false) === 0);
    this.cardAnimation += (0.08 * (cardsHidden ? GraphicsSettings.hudHideSpeed : GraphicsSettings.hudShowSpeed)) * (cardsHidden - this.cardAnimation);
    var uiScalar = 1 + 0.8 * this.cardAnimation;
    this.cardContainer.setPosition(-0.5 * (uiScalar * tgfGraphics.areaWidth - tgfGraphics.areaWidth), 0.5 * (uiScalar * tgfGraphics.areaHeight - tgfGraphics.areaHeight));
};
UIController.prototype._handleSettingsButtonMovement = function () {
    this.settingsButtonAnimation += (0.08 * (this.uiHidden ? GraphicsSettings.hudHideSpeed : GraphicsSettings.hudShowSpeed)) * (this.uiHidden - this.settingsButtonAnimation);
    var uiScalar = 1 + 0.8 * this.settingsButtonAnimation;
    this.buttonContainer.setPosition(0.5 * (uiScalar * tgfGraphics.areaWidth - tgfGraphics.areaWidth), 0.5 * (uiScalar * tgfGraphics.areaWidth - tgfGraphics.areaWidth));
};
UIController.prototype._handleLobbyButtonMovement = function () {
    this.lobbyButtonAnimation += (0.08 * (this.uiHidden ? GraphicsSettings.hudHideSpeed : GraphicsSettings.hudShowSpeed)) * (this.uiHidden - this.lobbyButtonAnimation);
    var uiScalar = 1 + 0.8 * this.lobbyButtonAnimation;
    if (this.isWaitingForPlayerWithoutDialog()) {
        this.lobbyButtonContainer.setPosition(tgfGraphics.areaWidth * 0.5, 0.5 * (uiScalar * tgfGraphics.areaHeight + 620));
    }
    else {
        this.lobbyButtonContainer.setPosition(tgfGraphics.areaWidth * 0.5, tgfGraphics.areaHeight + 250);
        this.lobbyButtonContainer.hide();
    }
};
UIController.prototype._handlePowerupMovement = function () {
    var powerupsHidden = this.uiHidden || (this.countPigs(true) === 0) || (this.countPigs(false) === 0);
    this.powerupsUiAnimation += (0.08 * (powerupsHidden ? GraphicsSettings.hudHideSpeed : GraphicsSettings.hudShowSpeed)) * (powerupsHidden - this.powerupsUiAnimation);
    var powerupsUiScalar = 1 + 0.8 * this.powerupsUiAnimation;
    if (!this.uiPowerUps.blockHiding) {
        this.uiPowerUps.setAnimationPositionY(0.5 * (powerupsUiScalar * tgfGraphics.areaHeight - tgfGraphics.areaHeight));
        if (powerupsUiScalar <= 1.05 && powerupsUiScalar !== 1 && !this.uiPowerUps.fullyEntered) {
            this.uiPowerUps._enableButtons(true);
            this.uiPowerUps.fullyEntered = true;
        }
    }
    if (powerupsUiScalar <= 1.0001 || this.isShooting()) {
        this.uiPowerUps.blockHiding = false;
    }
};
UIController.prototype._handleCardGlow = function () {
    var s = Math.sin(Date.now() * (0.001 * 1)) * (0.5 * 2) + (2.5 * 2);
    this.cardGlow.setScale(s, s);
};
UIController.prototype.toggleShowUIButtons = function (show) {
    if (show) {
        this.lobbyButton.show();
        this.mightyScopeButtonContainer.show();
        this.mightyScopeButtonHidden = true;
    }
    else {
        this.lobbyButton.hide();
        this.mightyScopeButtonContainer.hide();
        this.mightyScopeButtonHidden = true;
    }
};
UIController.prototype._handleScopeButtonUpdate = function () {
    this.checkMightyScopeCooldown();
    if (!this.mightyScopeButtonEnabled) {
        var remainingDuration = gameController.mightyScopeEnd - Date.now();
        var formattedText = this.formatDuration(remainingDuration);
        this.inactiveMightyScopeButtonText.setText(formattedText);
    }
    var mightyScopeButtonHidden = true; // this.uiHidden || this.isWaitingForPlayerWithoutDialog() || this.isWaitingScreenOpen() || playController.gameType == "practice";
    this.mightyScopeButtonAnimation += (0.08 * (mightyScopeButtonHidden ? GraphicsSettings.hudHideSpeed : GraphicsSettings.hudShowSpeed)) * (mightyScopeButtonHidden - this.mightyScopeButtonAnimation);
    var uiScalar = 1 + 0.8 * this.mightyScopeButtonAnimation;
    var xOffset = 80;
    var yOffset = 80;
    this.mightyScopeButtonContainer.setPosition(-0.5 * (uiScalar * tgfGraphics.areaWidth - tgfGraphics.areaWidth) + xOffset, -0.5 * (uiScalar * tgfGraphics.areaWidth - tgfGraphics.areaWidth) + yOffset);
};
UIController.prototype._handleScopeButtonClick = function () {
    var mightyScopeDialog = new MightyScopeDialog({});
    mightyScopeDialog.show();
};
UIController.prototype.formatDuration = function (duration) {
    var date = new Date(duration);
    var h = date.getUTCHours();
    var m = date.getUTCMinutes();
    var s = date.getUTCSeconds();
    if (s < 10) {
        s = "0" + s;
    }
    return ((h * 60) + m) + ":" + s;
};
UIController.prototype.checkMightyScopeCooldown = function () {
    this.toggleMightyScopeButton(Date.now() > gameController.mightyScopeEnd);
};
UIController.prototype.toggleMightyScopeButton = function (enable) {
    if (!this.mightyScopeButtonHidden) {
        if (enable) {
            this.mightyScopeButton.show();
            this.mightyScopeButton.activate();
            this.inactiveMightyScopeButton.hide();
            this.inactiveMightyScopeButtonText.hide();
            this.mightyScopeButtonEnabled = true;
        }
        else {
            this.mightyScopeButton.hide();
            this.inactiveMightyScopeButton.show();
            this.inactiveMightyScopeButton.activate();
            this.inactiveMightyScopeButtonText.show();
            this.inactiveMightyScopeButtonText.activate();
            this.mightyScopeButtonEnabled = false;
        }
    }
};
UIController.prototype.reinitializePowerUpUI = function () {
    var tempPos = {};
    if (this.uiPowerUps) {
        tempPos.x = this.uiPowerUps.x;
        tempPos.y = this.uiPowerUps.y;
        this.uiPowerUps.hide();
        this.uiPowerUps.free();
        this.uiPowerUps = null;
    }
    this.uiPowerUps = new PowerUpBarDialog({
        x: tempPos.x,
        y: tempPos.y,
        canSwapPigs: this.canSwapPigs,
        isPlacingPowerup: this.isPlacingPowerup
    });
    this.uiPowerUps.show();
    this.uiPowerUps.setState(this.uiPowerUps.STATE.NOTHING);
};
UIController.prototype.toggleInput = function (enable) {
    if (enable) {
        this.uiPowerUps.activate();
        this.ui.activate();
    }
    else {
        this.uiPowerUps.deactivate();
        this.ui.deactivate();
    }
};
UIController.prototype.freeUI = function () {
    if (this.ui) {
        this.ui.hide();
        this.ui.free();
        this.ui = null;
    }
    if (this.uiPowerUps) {
        this.uiPowerUps.hide();
        this.uiPowerUps.free();
        this.uiPowerUps = null;
    }
    if (this.scoreBarDialog) {
        this.scoreBarDialog.hide();
        this.scoreBarDialog.free();
    }
    this.ui = null;
    this.uiPowerUps = null;
    this.scoreBarDialog = null;
};
UIController.prototype.showPowerupBar = function () {
    "use strict";
    this.uiPowerUps.show();
};
UIController.prototype.hidePowerupBar = function () {
    "use strict";
    this.uiPowerUps.hide();
};
UIController.prototype.cancelPowerup = function () {
    if (this.uiPowerUps.getCurrentPowerUpIndex() !== -1) {
        this.uiPowerUps.cancelSelection();
    }
};
UIController.prototype.loadedOpponent = function (data, id) {
    this.scoreBarDialog.loadedOpponent(data, id);
};
